export function CheckboxCheckedGreenIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="1.11108" y="1.11108" width="17.7778" height="17.7778" rx="3.33333" fill="#12B76A" />
      <path d="M14.6289 6.52783L8.26315 12.8936L5.36963 10.0001" stroke="white" stroke-width="2.22222" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

CheckboxCheckedGreenIcon.displayName = 'CheckboxCheckedGreenIcon';
